import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "background-modal" }
const _hoisted_2 = { class: "wrapper-modal" }
const _hoisted_3 = { class: "wrapper-title" }
const _hoisted_4 = { class: "wrapper-create-image" }
const _hoisted_5 = { class: "wrapper-information" }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "background-image-slider" }
const _hoisted_8 = { class: "grid-image" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 2,
  class: "no-image"
}
const _hoisted_12 = { class: "wrapper-information" }
const _hoisted_13 = { class: "info" }
const _hoisted_14 = { class: "background-image-full" }
const _hoisted_15 = { class: "grid-image" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 2,
  class: "no-image"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseButton = _resolveComponent("CloseButton")!
  const _component_SecondaryButton = _resolveComponent("SecondaryButton")!
  const _component_DeleteButton = _resolveComponent("DeleteButton")!
  const _component_StandardButton = _resolveComponent("StandardButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("p", { class: "title" }, "Crear imagen para inventario", -1)),
        _createVNode(_component_CloseButton, { onClick: _ctx.closeModal }, null, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[7] || (_cache[7] = _createElementVNode("p", null, "Imagen slider", -1)),
            _createVNode(_component_SecondaryButton, {
              buttonLabel: 'Subir imagen',
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.fileImage1.click()))
            }),
            _createElementVNode("input", {
              type: "file",
              ref: "fileImage1",
              hidden: "",
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.uploadSlider && _ctx.uploadSlider(...args))),
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($event.target.value = ''))
            }, null, 544)
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text" }, "La imagen debe tener una relación 1200/430", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("figure", _hoisted_8, [
              (_ctx.showSliderPreview)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.previewSlider,
                    class: "image-slider"
                  }, null, 8, _hoisted_9))
                : (_ctx.additional?.slider)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _ctx.additional.slider,
                      class: "image-slider"
                    }, null, 8, _hoisted_10))
                  : (_openBlock(), _createElementBlock("p", _hoisted_11, "Sin imagen"))
            ]),
            (_ctx.showSliderPreview)
              ? (_openBlock(), _createBlock(_component_DeleteButton, {
                  key: 0,
                  class: "delete",
                  onClick: _ctx.removeUploadSlider
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _cache[9] || (_cache[9] = _createElementVNode("p", null, "Imagen completa", -1)),
            _createVNode(_component_SecondaryButton, {
              buttonLabel: 'Subir imagen',
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$refs.fileImage2.click()))
            }),
            _createElementVNode("input", {
              type: "file",
              ref: "fileImage2",
              hidden: "",
              onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.uploadBigImage && _ctx.uploadBigImage(...args))),
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($event.target.value = ''))
            }, null, 544)
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text" }, "La imagen debe tener una relación 1200/1440", -1)),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("figure", _hoisted_15, [
              (_ctx.showBigImagePreview)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.previewBigImage,
                    class: "image-full"
                  }, null, 8, _hoisted_16))
                : (_ctx.additional?.full)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _ctx.additional.full,
                      class: "image-full"
                    }, null, 8, _hoisted_17))
                  : (_openBlock(), _createElementBlock("p", _hoisted_18, "Sin imagen"))
            ]),
            (_ctx.showBigImagePreview)
              ? (_openBlock(), _createBlock(_component_DeleteButton, {
                  key: 0,
                  class: "delete",
                  onClick: _ctx.removeUploadBigImage
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode(_component_StandardButton, {
        buttonLabel: 'Guardar',
        class: "margin-button",
        "is-disabled": _ctx.disabledForm,
        onClick: _ctx.createEditInventoryImage
      }, null, 8, ["is-disabled", "onClick"])
    ])
  ]))
}